/*! CyberData Media Page - version 2026-10-19 18:11 */
/* CyberData Media Page, website version. Built from ~/media-page/app/static/index.html (shared logic). */
(function(){
if(!document.getElementById("cd-media")) return;
// ---------- icons (24x24 stroke) ----------
const I = {
  all:      '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>',
  products: '<path d="M21 8 12 3 3 8v8l9 5 9-5z"/><path d="m3 8 9 5 9-5M12 13v8"/>',
  speaker:  '<path d="M11 5 6 9H3v6h3l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13"/>',
  intercom: '<rect x="5" y="2" width="14" height="20" rx="2"/><circle cx="12" cy="17" r="2"/><path d="M9 6h6M9 9h6M9 12h6"/>',
  server:   '<rect x="3" y="4" width="18" height="7" rx="1.5"/><rect x="3" y="13" width="18" height="7" rx="1.5"/><path d="M7 7.5h.01M7 16.5h.01M11 7.5h6M11 16.5h6"/>',
  bell:     '<path d="M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.9 1.9 0 0 0 3.4 0"/>',
  plug:     '<path d="M9 2v6M15 2v6M6 8h12v3a6 6 0 0 1-12 0zM12 17v5"/>',
  marketing:'<path d="M3 11v2a1 1 0 0 0 1 1h2l5 4V6L6 10H4a1 1 0 0 0-1 1z"/><path d="M15 8a5 5 0 0 1 0 8M11 6l8-3v18l-8-3"/>',
  blog:     '<path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/>',
  award:    '<circle cx="12" cy="8" r="6"/><path d="M15.5 13 17 22l-5-3-5 3 1.5-9"/><path d="m9.5 8 1.8 1.8L14.8 6.3"/>',
  megaphone:'<path d="m3 11 15-6v14L3 13z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/><path d="M21 9v6"/>',
  book:     '<path d="M2 4h6a4 4 0 0 1 4 4v13a3 3 0 0 0-3-3H2z"/><path d="M22 4h-6a4 4 0 0 0-4 4v13a3 3 0 0 1 3-3h7z"/>',
  layers:   '<path d="m12 2 10 5-10 5L2 7z"/><path d="m2 17 10 5 10-5M2 12l10 5 10-5"/>',
  news:     '<path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"/><path d="M18 14h-8M15 18h-5M10 6h8v4h-8z"/>',
  palette:  '<circle cx="13.5" cy="6.5" r="1"/><circle cx="17.5" cy="10.5" r="1"/><circle cx="8.5" cy="7.5" r="1"/><circle cx="6.5" cy="12.5" r="1"/><path d="M12 2a10 10 0 0 0 0 20c.9 0 1.7-.8 1.7-1.7 0-.4-.2-.8-.4-1.1-.3-.3-.4-.7-.4-1.1 0-.9.8-1.7 1.7-1.7H16a6 6 0 0 0 6-6c0-4.9-4.5-8.4-10-8.4z"/>',
  cap:      '<path d="M22 10 12 5 2 10l10 5z"/><path d="M6 12v5c3 2 9 2 12 0v-5M22 10v6"/>',
  mic:      '<rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 10a7 7 0 0 0 14 0M12 17v5M8 22h8"/>',
  bulb:     '<path d="M9 18h6M10 22h4"/><path d="M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.2 1 2V18h6v-1.3c0-.8.4-1.5 1-2A7 7 0 0 0 12 2z"/>',
  key:      '<circle cx="7.5" cy="15.5" r="4.5"/><path d="m10.7 12.3 9.8-9.8M17 6l3 3M14.5 8.5l2 2"/>',
  film:     '<rect x="2" y="3" width="20" height="18" rx="2"/><path d="M7 3v18M17 3v18M2 8h5M2 16h5M17 8h5M17 16h5M2 12h20"/>',
  youtube:  '<rect x="2" y="5" width="20" height="14" rx="4"/><path d="m10 9 5 3-5 3z" fill="currentColor"/>',
  folder:   '<path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.7-.9l-.8-1.2A2 2 0 0 0 7.9 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z"/>',
};
const svg = (k) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${I[k]||I.folder}</svg>`;

// Product functions, then marketing categories (keyed by their folder name on disk).
const PRODUCT_GROUPS = {
  Speakers:     {icon:"speaker",  color:"Speakers"},
  Intercoms:    {icon:"intercom", color:"Intercoms"},
  Servers:      {icon:"server",   color:"Servers"},
  Notification: {icon:"bell",     color:"Notification"},
  Accessory:    {icon:"plug",     color:"Accessory"},
};
const MARKETING_GROUPS = {
  "Blogs":               {label:"Blogs",                icon:"blog",    color:"Blogs"},
  "Case Studies":        {label:"Case Studies",         icon:"award",     color:"Cases"},
  "Flyers":              {label:"Flyers",               icon:"megaphone", color:"Flyers"},
  "Marketing Colaterol": {label:"Marketing Collateral", icon:"book",      color:"Collateral"},
  "Marketing Collateral":{label:"Marketing Collateral", icon:"book",      color:"Collateral"},
  "Press Releases":      {label:"Press Releases",       icon:"news",    color:"Press"},
  "CD Logos":            {label:"Logos & Brand",        icon:"palette", color:"Logos"},
  "Logos & Brand":       {label:"Logos & Brand",        icon:"palette", color:"Logos"},
  "YouTube":             {label:"YouTube",              icon:"youtube", color:"YouTube"},
};
// YouTube playlists, by title; anything else gets the film icon.
const YOUTUBE_GROUPS = {
  "CyberSchool":                  {icon:"cap"},
  "From the President":           {icon:"mic"},
  "Demystifying Overhead Paging": {icon:"bulb"},
  "Intercoms":                    {icon:"intercom"},
  "Access Control":               {icon:"key"},
  "More Videos":                  {icon:"film"},
};
const ymeta = t => ({label:t, icon:(YOUTUBE_GROUPS[t] || {icon:"film"}).icon, color:"YouTube"});
const pmeta = f => PRODUCT_GROUPS[f] || {icon:"products", color:"Other"};
const mmeta = c => MARKETING_GROUPS[c] || {label:c, icon:"folder", color:"Other"};
const ico = (k, color) => `<span class="ico" style="background:var(--${color}-soft);color:var(--${color})">${svg(k)}</span>`;

const S = {sort:"num", filter:"all", q:"", open:null, items:[]};
// The files (and Program/catalog.js listing them) live on files.cyberdata.net; data-base on #cd-media says where.
const ROOT = document.getElementById("cd-media");
const BASE = (ROOT.dataset.base || "").replace(/\/?$/, "/");
const abs = u => u && !/^(https?:)?\/\//.test(u) ? BASE + u : u;
const $ = s => document.querySelector(s);
const esc = s => String(s ?? "").replace(/[&<>"]/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));

// Every card is an item: kind "p" (one product) or "c" (one marketing category). group = function or category.
function productFunctions(){
  const known = Object.keys(PRODUCT_GROUPS);
  const have = new Set(S.items.filter(i => i.kind==="p").map(i => i.group));
  return [...known.filter(f => have.has(f)), ...[...have].filter(f => !known.includes(f)).sort()];
}
function marketingCats(){
  return S.items.filter(i => i.kind==="c" && !i.yt).map(i => i.group);
}
function youtubeCats(){
  return S.items.filter(i => i.yt).map(i => i.group);
}
const uniqueVideos = cards => new Set(cards.flatMap(i => hits(i).map(k => i.files[k].id))).size;

// ---------- the Show dropdown ----------
function options(){
  const count = pred => S.items.filter(pred).length;
  const o = [{v:"all", label:"All", icon:"all", color:"Other", n:""}];
  const pf = productFunctions();
  if(pf.length){
    o.push({group:"Products"});
    o.push({v:"p:*", label:"All products", icon:"products", color:"Other", n:count(i => i.kind==="p")});
    pf.forEach(f => o.push({v:"p:"+f, label:f, icon:pmeta(f).icon, color:pmeta(f).color, n:count(i => i.kind==="p" && i.group===f)}));
  }
  const mc = marketingCats();
  if(mc.length){
    o.push({group:"Marketing"});
    const files = pred => S.items.filter(i => i.kind==="c" && !i.yt && pred(i)).reduce((n, i) => n + i.files.length, 0);
    o.push({v:"m:*", label:"All marketing", icon:"layers", color:"Other", n:files(() => true)});
    mc.forEach(c => o.push({v:"m:"+c, label:mmeta(c).label, icon:mmeta(c).icon, color:mmeta(c).color, n:files(i => i.group===c)}));
  }
  const yc = youtubeCats();
  if(yc.length){
    const cards = S.items.filter(i => i.yt);
    o.push({group:"YouTube"});
    o.push({v:"y:*", label:"All videos", icon:"youtube", color:"YouTube", n:new Set(cards.flatMap(i => i.files.map(f => f.id))).size});
    cards.forEach(i => o.push({v:i.id, label:i.title, icon:ymeta(i.group).icon, color:"YouTube", n:i.files.length}));
  }
  return o;
}
function drawDropdown(){
  const o = options();
  const cur = o.find(x => x.v===S.filter) || o[0];
  $("#ddbtn").innerHTML = `${ico(cur.icon, cur.color)}<span>${esc(cur.label)}</span><svg class="caret" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="m6 9 6 6 6-6"/></svg>`;
  $("#ddmenu").innerHTML = o.map(x => x.group
    ? `<div class="dd-group">${esc(x.group)}</div>`
    : `<button class="dd-opt" role="option" data-v="${esc(x.v)}" aria-selected="${x.v===S.filter}">${ico(x.icon, x.color)}<span>${esc(x.label)}</span><span class="n">${x.n}</span></button>`).join("");
  // Sorting only applies to products.
  $("#sortctl").hidden = S.filter.startsWith("m:") || S.filter.startsWith("y:");
}
function openMenu(open){
  $("#ddmenu").hidden = !open;
  $("#ddbtn").setAttribute("aria-expanded", open);
  if(open) ($("#ddmenu .dd-opt[aria-selected='true']") || $("#ddmenu .dd-opt"))?.focus();
}

// ---------- list ----------
const has = (s, q) => String(s || "").toLowerCase().includes(q);
// Which files of a category card match the search (all of them when the category name matches).
function hits(i){
  const q = S.q.trim().toLowerCase();
  if(!q || has(i.title, q)) return i.files.map((_, k) => k);
  return i.files.map((f, k) => [f, k]).filter(([f]) => [f.name, f.label, f.setTitle].some(s => has(s, q))).map(([, k]) => k);
}
function matches(i){
  const q = S.q.trim().toLowerCase();
  if(!q) return true;
  if(i.kind==="c") return hits(i).length > 0;
  return [i.id, i.title, ...i.files.map(f => f.name)].some(s => has(s, q));
}
function sections(){
  const f = S.filter, v = S.items.filter(matches);
  const prods = v.filter(i => i.kind==="p").sort((a,b) => a.id.localeCompare(b.id, undefined, {numeric:true}));
  const cats = v.filter(i => i.kind==="c" && !i.yt), yts = v.filter(i => i.yt);
  const out = [];
  if(f==="all" || f.startsWith("p:")){
    const want = f.startsWith("p:") && f!=="p:*" ? [f.slice(2)] : null;
    if(S.sort==="fn" || want){
      (want || productFunctions()).forEach(g => out.push({h:g, icon:pmeta(g).icon, color:pmeta(g).color, items:prods.filter(i => i.group===g)}));
    } else {
      out.push({h:"Products", icon:"products", color:"Other", items:prods});
    }
  }
  if(f==="all" || f.startsWith("m:")){
    const one = f.startsWith("m:") && f!=="m:*" ? f.slice(2) : null;
    out.push(one ? {h:mmeta(one).label, icon:mmeta(one).icon, color:mmeta(one).color, items:cats.filter(i => i.group===one)}
                 : {h:"Marketing", icon:"layers", color:"Other", items:cats});
  }
  if(f==="all" || f.startsWith("y:")){
    const one = f.startsWith("y:") && f!=="y:*" ? yts.filter(i => i.id===f) : null;
    out.push(one ? {h:one[0]?.title || "YouTube", icon:ymeta(one[0]?.group).icon, color:"YouTube", items:one}
                 : {h:"YouTube", icon:"youtube", color:"YouTube", items:yts});
  }
  return out.filter(s => s.items.length);
}

function card(i){
  const n = i.kind==="c" ? hits(i).length : i.files.filter(f => !isTranslation(f)).length;
  const m = i.kind==="p" ? pmeta(i.group) : i.yt ? ymeta(i.group) : mmeta(i.group);
  const label = i.kind==="p" ? i.group : i.yt ? "YouTube" : "Marketing";
  const thumb = i.photo && i.yt
    ? `<img class="cover" src="${esc(i.photo)}" alt="" loading="lazy"><span class="badge"><svg width="18" height="18" viewBox="0 0 24 24" fill="#fff"><path d="M8 5v14l11-7z"/></svg></span>`
    : i.photo
    ? `<img src="${esc(i.photo)}" alt="" loading="lazy">`
    : i.kind==="c" ? `<span class="big" style="background:var(--${m.color}-soft);color:var(--${m.color})">${svg(m.icon)}</span>`
    : `<span class="none">No photo yet</span>`;
  return `<div class="card" role="button" tabindex="0" data-id="${esc(i.id)}" aria-expanded="${S.open===i.id}">
    <div class="thumb">${thumb}</div>
    ${i.web ? `<a class="weblink" href="${esc(i.web)}" target="_blank" rel="noopener">View on cyberdata.net <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M7 17 17 7M8 7h9v9"/></svg></a>` : ""}
    <div class="meta">${i.kind==="p" ? `<span class="pn">${esc(i.id)}</span>` : (i.sub ? `<span class="pn">${esc(i.sub)}</span>` : "")}
      <span class="pname${i.title?"":" missing"}${i.kind==="c"?" cat":""}">${i.title ? esc(i.title) : "Not in product list"}</span>
      <div class="tagrow"><span class="tag" style="background:var(--${m.color}-soft);color:var(--${m.color})">${esc(label)}</span>
      <span class="fcount">${n} ${i.yt ? "video" : "file"}${n===1?"":"s"} <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="m6 9 6 6 6-6"/></svg></span></div>
    </div></div>`;
}

function fileBtn(f, k, title, extra){
  return `<button class="file" data-k="${k}"><span class="ficon ft-${f.type}">${f.type.toUpperCase()}</span><span class="finfo"><span class="fkind">${esc(title)}</span><span class="fname">${extra ? esc(extra) + " · " : ""}${esc(f.name)} · ${esc(f.size)}</span>${f.view ? "" : `<span class="dl-note">Downloads to open in ${f.type==="ai" ? "Illustrator" : "Word"}</span>`}</span></button>`;
}
// Translated datasheets (FR/DE/ES) show as language buttons under the English one, not as files of their own.
const LANG_NAMES = {EN:"English", FR:"Français", DE:"Deutsch", ES:"Español"};
const isTranslation = f => f.lang && f.lang !== "EN";
function productFiles(i){
  const tr = i.files.map((f, k) => [f, k]).filter(([f]) => isTranslation(f));
  return i.files.map((f, k) => {
    if(isTranslation(f)) return "";
    const langs = f.lang ? tr.filter(([t]) => t.label === f.label) : [];
    if(!langs.length) return fileBtn(f, k, f.label);
    return `<div class="sheet">${fileBtn(f, k, f.label)}<div class="langs" role="group" aria-label="Datasheet language">`
      + [[f, k], ...langs].map(([t, j]) => `<button class="lang" data-k="${j}" title="${esc(LANG_NAMES[t.lang] || t.lang)}">${esc(t.lang)}</button>`).join("")
      + `</div></div>`;
  }).join("");
}
function categoryFiles(i){
  const show = new Set(hits(i));
  let html = "", flat = [];
  const flush = () => { if(flat.length){ html += `<div class="files">${flat.join("")}</div>`; flat = []; } };
  i.sets.forEach(s => {
    const ks = s.idx.filter(k => show.has(k));
    if(!ks.length) return;
    if(s.idx.length === 1){ const f = i.files[ks[0]]; flat.push(fileBtn(f, ks[0], f.setTitle, f.date)); return; }
    flush();
    html += `<div class="set-h">${svg("folder")}<span>${esc(s.title)}</span><span class="n">${s.idx.length} files</span></div>`
          + `<div class="files">${ks.map(k => fileBtn(i.files[k], k, i.files[k].label)).join("")}</div>`;
  });
  flush();
  return html;
}
const fmtDate = d => d ? new Date(d + "T12:00:00").toLocaleDateString("en-US", {month:"short", day:"numeric", year:"numeric"}) : "";
const fmtDur = s => s == null ? "" : `${Math.floor(s/60)}:${String(s%60).padStart(2,"0")}`;
function videoTile(v, k){
  return `<button class="vid" data-k="${k}" title="${esc(v.title)}"><span class="vthumb"><img src="${esc(v.thumb || `https://i.ytimg.com/vi/${v.id}/mqdefault.jpg`)}" alt="" loading="lazy">`
    + `${v.seconds != null ? `<span class="dur">${fmtDur(v.seconds)}</span>` : ""}<span class="play"><span><svg width="18" height="18" viewBox="0 0 24 24" fill="#fff"><path d="M8 5v14l11-7z"/></svg></span></span></span>`
    + `<span class="vt">${esc(v.title)}</span><span class="vd">${[fmtDate(v.date), v.kind==="short" ? "Short" : ""].filter(Boolean).join(" · ")}</span></button>`;
}
function videoGrid(i){
  const show = new Set(hits(i)), part = kind => i.files.map((v, k) => [v, k]).filter(([v, k]) => v.kind===kind && show.has(k));
  const vids = part("video"), shorts = part("short");
  return (vids.length ? `<div class="vids">${vids.map(([v, k]) => videoTile(v, k)).join("")}</div>` : "")
    + (shorts.length ? `${vids.length ? `<div class="set-h">${svg("youtube")}<span>Shorts</span><span class="n">${shorts.length}</span></div>` : ""}<div class="vids">${shorts.map(([v, k]) => videoTile(v, k)).join("")}</div>` : "");
}
function drawer(i){
  const body = !i.files.length
    ? `<p class="path">${i.folder ? "This folder has no files the page can show yet." : `No folder named ${esc(i.id)} in the media folder yet.`}</p>`
    : i.yt ? videoGrid(i)
    : i.kind==="c" ? categoryFiles(i)
    : `<div class="files">${productFiles(i)}</div>`;
  const head = i.kind==="p" ? `<span class="pn">${esc(i.id)}</span>${esc(i.title)}` : esc(i.title);
  if(i.yt) return `<div class="drawer" id="drawer"><div class="drawer-h"><h3>${esc(i.title)}</h3><a class="path" href="${esc(i.link)}" target="_blank" rel="noopener">${i.list ? "Open this playlist" : "Open the channel"} on YouTube ↗</a></div>${body}</div>`;
  return `<div class="drawer" id="drawer">
    <div class="drawer-h"><h3>${head}</h3>${i.folder?`<span class="path">${esc(i.folder)}/</span>`:""}</div>${body}</div>`;
}

function render(){
  const secs = sections();
  const shown = secs.reduce((n, s) => n + s.items.length, 0);
  const prods = secs.flatMap(s => s.items).filter(i => i.kind==="p").length;
  const shownCats = secs.flatMap(s => s.items).filter(i => i.kind==="c");
  const mfiles = shownCats.filter(i => !i.yt).reduce((n, i) => n + hits(i).length, 0);
  const vids = uniqueVideos(shownCats.filter(i => i.yt));
  $("#count").textContent = [prods && `${prods} product${prods===1?"":"s"}`, mfiles && `${mfiles} marketing file${mfiles===1?"":"s"}`, vids && `${vids} video${vids===1?"":"s"}`].filter(Boolean).join(" · ") || "Nothing shown";
  $("#list").innerHTML = secs.map(s => `<section class="group"><div class="group-h">${ico(s.icon, s.color)}<h2>${esc(s.h)}</h2><span class="n">${s.items.length}</span></div><div class="cdm-grid">${s.items.map(card).join("")}</div></section>`).join("")
    || `<p class="msg">${S.items.length ? "Nothing matches. Clear the search or pick something else under Show." : "Nothing found. Check that the media folder has 01-number folders in it."}</p>`;
  placeDrawer();
}

// Put the drop-down right below the row holding the open card.
function placeDrawer(){
  document.getElementById("drawer")?.remove();
  const c = [...document.querySelectorAll(".card")].find(x => x.dataset.id===S.open);
  if(!c) return;
  const i = S.items.find(x => x.id===S.open);
  const row = [...c.parentElement.children].filter(e => e.classList.contains("card") && e.offsetTop===c.offsetTop);
  row[row.length-1].insertAdjacentHTML("afterend", drawer(i));
  const d = document.getElementById("drawer");
  d.style.setProperty("--caret", (c.offsetLeft - d.offsetLeft + c.offsetWidth/2 - 6) + "px");
  d.querySelectorAll(".file, .lang").forEach(b => b.onclick = () => openFile(i, i.files[+b.dataset.k]));
  d.querySelectorAll(".vid").forEach(b => b.onclick = () => openVideo(i.files[+b.dataset.k]));
}

let current = null;
function openFile(i, f){
  if(!f.view || (f.type==="docx" && !f.doc)){ saveFile(f); return; }  // Illustrator etc.: just download
  current = f;
  $("#vprint").hidden = false; $("#vdl").hidden = false; $("#vyt").hidden = true;
  $("#vicon").className = `ficon ft-${f.type}`; $("#vicon").textContent = f.type.toUpperCase();
  $("#vkind").textContent = i.kind==="p" ? `${i.id} · ${f.label}${isTranslation(f) ? " · " + (LANG_NAMES[f.lang] || f.lang) : ""}` : f.single ? f.setTitle : `${f.setTitle} · ${f.label}`;
  $("#vname").textContent = `${f.name} · ${f.size}`;
  $("#vpath").textContent = decodeURIComponent(f.url.replace(BASE, "").replace(/^Content\//, ""));
  $("#vdl").href = dlUrl(f); $("#vdl").setAttribute("download", f.name);
  $("#vbody").innerHTML = f.type==="pdf" || f.type==="docx"
    ? `<iframe src="${esc(f.type==="docx" ? docPage(f) : f.url)}" title="${esc(f.name)}"></iframe>`
    : `<div class="img"><img src="${esc(f.url)}" alt="${esc(i.title || i.id)}"></div>`;
  $("#viewer").hidden = false; $("#vclose").focus();
}
// Browsers ignore "download" for files on another site, so ?download=1 asks files.cyberdata.net
// (its .htaccess in the Media-Page folder) to send the file as an attachment instead.
const dlUrl = f => f.url + (f.url.includes("?") ? "&" : "?") + "download=1";
// Word files come pre-drawn as web pages (Program/Documents); "#print" makes one print itself.
const docPage = (f, print) => f.doc + (print ? "#print" : "");
function saveFile(f){
  const a = document.createElement("a");
  a.href = dlUrl(f); a.download = f.name;
  document.body.appendChild(a); a.click(); a.remove();
}
function openVideo(v){
  current = null;
  const watch = `https://www.youtube.com/watch?v=${encodeURIComponent(v.id)}`;
  $("#vprint").hidden = true; $("#vdl").hidden = true; $("#vyt").hidden = false; $("#vyt").href = watch;
  $("#vicon").className = "ficon ft-yt"; $("#vicon").textContent = v.kind==="short" ? "SHORT" : "VIDEO";
  $("#vkind").textContent = v.title;
  $("#vname").textContent = [fmtDate(v.date), fmtDur(v.seconds)].filter(Boolean).join(" · ");
  $("#vpath").textContent = watch;
  $("#vbody").innerHTML = v.embed === false
    ? `<p class="novid">This video can only be played on YouTube.<br><br><a class="btn primary" href="${esc(watch)}" target="_blank" rel="noopener">Watch on YouTube</a></p>`
    : `<iframe src="https://www.youtube-nocookie.com/embed/${encodeURIComponent(v.id)}?autoplay=1&rel=0" title="${esc(v.title)}" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>`;
  $("#viewer").hidden = false; $("#vclose").focus();
}
function closeViewer(){ $("#viewer").hidden = true; $("#vbody").innerHTML = ""; }

function printCurrent(){
  if(!current) return;
  const fr = $("#printer");
  if(current.type==="docx"){ fr.onload = null; fr.src = docPage(current, true); return; }
  if(current.type!=="pdf"){  // a photo: print it from a small page drawn right here
    fr.onload = null;
    fr.srcdoc = `<!doctype html><style>@page{margin:12mm}body{margin:0}img{max-width:100%;max-height:100vh;display:block;margin:auto}</style>`
      + `<img src="${esc(current.url)}" onload="setTimeout(()=>print(),100)">`;
    return;
  }
  window.open(current.url, "_blank");  // a PDF from files.cyberdata.net: print it from the browser's PDF viewer
}

// ---------- events ----------
document.addEventListener("click", e => {
  if(e.target.closest("#ddbtn")){ openMenu($("#ddmenu").hidden); return; }
  const o = e.target.closest(".dd-opt");
  if(o){ S.filter = o.dataset.v; S.open = S.filter.startsWith("m:") && S.filter!=="m:*" ? "c:" + S.filter.slice(2)
        : S.filter.startsWith("y:") && S.filter!=="y:*" ? S.filter : null; openMenu(false); $("#ddbtn").focus(); drawDropdown(); render(); return; }
  if(!e.target.closest("#dd")) openMenu(false);
  const s = e.target.closest("[data-sort]");
  if(s){ S.sort = s.dataset.sort; document.querySelectorAll("[data-sort]").forEach(b => b.setAttribute("aria-pressed", b===s)); render(); return; }
  if(e.target.closest(".weblink")) return;  // open the website, don't toggle the card
  const c = e.target.closest(".card");
  if(c){ S.open = S.open===c.dataset.id ? null : c.dataset.id; document.querySelectorAll(".card").forEach(x => x.setAttribute("aria-expanded", x.dataset.id===S.open)); placeDrawer(); }
});
document.addEventListener("keydown", e => {
  if(!$("#ddmenu").hidden){
    const opts = [...document.querySelectorAll(".dd-opt")], k = opts.indexOf(document.activeElement);
    if(e.key==="Escape"){ openMenu(false); $("#ddbtn").focus(); e.preventDefault(); return; }
    if(e.key==="ArrowDown"){ opts[Math.min(k+1, opts.length-1)]?.focus(); e.preventDefault(); return; }
    if(e.key==="ArrowUp"){ opts[Math.max(k-1, 0)]?.focus(); e.preventDefault(); return; }
  }
  const c = e.target.closest?.(".card");
  if(c && e.target===c && (e.key==="Enter" || e.key===" ")){ e.preventDefault(); c.click(); }
  if(e.key==="Escape" && !$("#viewer").hidden) closeViewer();
});
$("#q").addEventListener("input", e => { S.q = e.target.value; render(); });  // render() redraws the open drawer too
$("#vclose").onclick = closeViewer;
$("#vprint").onclick = printCurrent;
$("#viewer").addEventListener("click", e => { if(e.target.id==="viewer") closeViewer(); });
let rt; addEventListener("resize", () => { clearTimeout(rt); rt = setTimeout(placeDrawer, 120); });

// One card per marketing category; its files keep which item (flyer set, blog) they belong to.
function categoryCard(c){
  const files = [], sets = [];
  c.items.forEach(m => {
    const set = {title:m.title, idx:[]};
    m.files.forEach(f => { set.idx.push(files.length); files.push({...f, setTitle:m.title, date:m.date, single:m.files.length===1}); });
    sets.push(set);
  });
  const dates = c.items.map(m => m.date).filter(Boolean);  // newest first from the server
  const sub = dates.length > 1 ? `${dates[dates.length-1]} – ${dates[0]}` : (dates[0] || "");
  return {kind:"c", id:"c:"+c.category, title:mmeta(c.category).label, sub, group:c.category, folder:"Marketing/"+c.category, photo:null, sets, files};
}

// One YouTube card per playlist (in YouTube's order), plus "More Videos" for videos in no playlist.
// A card's "files" are its videos, newest first.
function youtubeCards(y){
  const byId = Object.fromEntries(y.videos.map(v => [v.id, {...v, name:v.title, label:v.title, setTitle:v.title}]));
  const newest = (a, b) => String(b.date || "").localeCompare(String(a.date || ""));
  const card = (title, vids, list) => {
    const n = vids.length, shorts = vids.filter(v => v.kind==="short").length;
    const newest1 = [...vids].sort(newest)[0];
    const photo = newest1 ? (newest1.thumb || `https://i.ytimg.com/vi/${newest1.id}/mqdefault.jpg`) : null;
    return {kind:"c", yt:true, id:"y:" + title, title, group:title, list, photo, sets:[],
      link: list ? `https://www.youtube.com/playlist?list=${encodeURIComponent(list)}` : y.channel,
      sub: shorts===n ? "Shorts" : "", files:[...vids].sort(newest)};
  };
  const cards = (y.playlists || []).map(p => card(p.title, p.ids.map(id => byId[id]).filter(Boolean), p.id)).filter(c => c.files.length);
  const listed = new Set((y.playlists || []).flatMap(p => p.ids));
  const rest = y.videos.filter(v => !listed.has(v.id)).map(v => byId[v.id]);
  if(rest.length) cards.push(card("More Videos", rest, null));
  return cards;
}

function fix(f){ return {...f, url:abs(f.url), doc:abs(f.doc)}; }
function start(d){
  S.items = [
    ...d.products.map(p => ({kind:"p", id:p.pn, title:p.name, group:p.function, folder:p.folder, photo:abs(p.photo), web:p.web, files:p.files.map(fix)})),
    ...(d.marketing || []).map(c => categoryCard({...c, items:c.items.map(m => ({...m, files:m.files.map(fix)}))})),
    ...(d.youtube && d.youtube.videos.length ? youtubeCards({...d.youtube, videos:d.youtube.videos.map(v => ({...v, thumb:abs(v.thumb)}))}) : []),
  ];
  drawDropdown(); render();
}
const failed = () => { $("#list").innerHTML = `<p class="msg">The media library could not be loaded right now. Please try again later.</p>`; };
const tag = document.createElement("script");
tag.src = BASE + "Program/catalog.js?v=" + Math.floor(Date.now() / 300000);
tag.onload = () => { try { start(window.MEDIA_CATALOG); } catch(e){ console.error(e); failed(); } };
tag.onerror = failed;
document.head.appendChild(tag);
})();
